var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClipPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_396_33329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_396_33329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33329 11.9998C7.33329 12.7332 6.73329 13.3332 5.99996 13.3332C5.26663 13.3332 4.66663 12.7332 4.66663 11.9998C4.66663 11.2665 5.26663 10.6665 5.99996 10.6665C6.73329 10.6665 7.33329 11.2665 7.33329 11.9998ZM5.99996 6.6665C5.26663 6.6665 4.66663 7.2665 4.66663 7.99984C4.66663 8.73317 5.26663 9.33317 5.99996 9.33317C6.73329 9.33317 7.33329 8.73317 7.33329 7.99984C7.33329 7.2665 6.73329 6.6665 5.99996 6.6665ZM5.99996 2.6665C5.26663 2.6665 4.66663 3.2665 4.66663 3.99984C4.66663 4.73317 5.26663 5.33317 5.99996 5.33317C6.73329 5.33317 7.33329 4.73317 7.33329 3.99984C7.33329 3.2665 6.73329 2.6665 5.99996 2.6665ZM9.99996 5.33317C10.7333 5.33317 11.3333 4.73317 11.3333 3.99984C11.3333 3.2665 10.7333 2.6665 9.99996 2.6665C9.26663 2.6665 8.66663 3.2665 8.66663 3.99984C8.66663 4.73317 9.26663 5.33317 9.99996 5.33317ZM9.99996 6.6665C9.26663 6.6665 8.66663 7.2665 8.66663 7.99984C8.66663 8.73317 9.26663 9.33317 9.99996 9.33317C10.7333 9.33317 11.3333 8.73317 11.3333 7.99984C11.3333 7.2665 10.7333 6.6665 9.99996 6.6665ZM9.99996 10.6665C9.26663 10.6665 8.66663 11.2665 8.66663 11.9998C8.66663 12.7332 9.26663 13.3332 9.99996 13.3332C10.7333 13.3332 11.3333 12.7332 11.3333 11.9998C11.3333 11.2665 10.7333 10.6665 9.99996 10.6665Z",
    fill: "#757582"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClipPath);
export default __webpack_public_path__ + "static/media/ic_clip-path.10ed8843c32fda1fe2863861e7ee4166.svg";
export { ForwardRef as ReactComponent };